export default function useEventTheme() {
  // Never use the event settings - use the fixed theme instead.
  // Otherwise the secondary color gets overwritten.
  return {};
}
